<template>
      <b-nav-item-dropdown right no-caret>
        <template slot="button-content">
          <span>
            <i class="fa fa-globe"></i>
            <span v-if="this.checkLanguage === 'ja'" class="label label-warning">日本語 </span>
            <span v-else-if="this.checkLanguage === 'en'" class="label label-warning">English</span>
            <span v-else-if="this.checkLanguage === 'zh_tr'" class="label label-warning">繁體中文 </span>
          </span>
        </template>
        <b-dropdown-item @click="changeLanguage('ja')"><img class="flag" :src="'static/img/flag/flag_japan.png'" alt="">日本語 <small>{{$t('transLanguage.ja')}}</small></b-dropdown-item>
        <b-dropdown-item @click="changeLanguage('en')"><img class="flag" :src="'static/img/flag/flag_usa.png'" alt="">English <small>{{$t('transLanguage.en')}}</small></b-dropdown-item>
        <b-dropdown-item @click="changeLanguage('zh_tr')"><img  class="flag" :src="'static/img/flag/flag_china.png'" alt="">繁體中文 <small>{{$t('transLanguage.ch')}}</small></b-dropdown-item>
      </b-nav-item-dropdown>
</template>
<script>
import { transLanguage, i18n } from '@/main.js'
import CommonJs from '@/js/common'

export default {
  name: 'TransLangDropdown',
  mixins: [CommonJs],
  data: () => {
    return {
    }
  },
  computed: {
    checkLanguage () {
      return i18n.locale
    }
  },
  mounted: function () {
    // transLanguage(locale)
    // if (locale === 'ja') this.language = locale
    // else if (locale === 'en') this.language = locale
    // else if (locale === 'zh_tr') this.language = locale
  },
  methods: {
    changeLanguage: function (locale) {
      transLanguage(locale)
      try {
        if (window.localStorage) {
          localStorage.setItem('language', locale)
        } else {
          // alert('言語切り替えをするには、ブラウザ設定でLocalStorageを有効にする必要があります')
        }
      } catch (e) {
        // alert('言語切り替えをするには、ブラウザ設定でLocalStorageを有効にする必要があります')
        console.log('storage error::', e)
      }
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .flex-option{
    display: flex;
    flex-direction: column-reverse;
  }
  .ibox-child:first-of-type {
    border-top: solid 1px #e7eaec;
  }
  .ibox-child:last-of-type {
    border-top: 0px;
  }
  .no-margin{
    margin: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Header/TransLangDropdown.vue